import { useRef } from 'react';
import { Transition } from 'react-transition-group';
import GearIcon from '../../../../assets/images/svg/GearIcon';
import { useDisclosure } from '../../../hooks';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import { classNames } from '../../../utils';
import SettingsMenu from './SettingsMenu';

function UserSettings(): JSX.Element {
  const menuRef = useRef(null);
  const transitionRef = useRef(null);
  const { isOpen, toggle, close } = useDisclosure(false);

  const duration = 300;
  const defaultStyle: React.CSSProperties = {
    transition: `opacity ${duration}ms ease-in-out`,
    opacity: 0,
    zIndex: 0,
    pointerEvents: 'none',
  };

  const transitionStyles: Record<string, React.CSSProperties> = {
    entering: { opacity: 1, zIndex: 999, pointerEvents: 'auto' },
    entered: { opacity: 1, zIndex: 999, pointerEvents: 'auto' },
    exiting: { opacity: 1, zIndex: 999, pointerEvents: 'none' },
    exited: { opacity: 0, zIndex: 999, pointerEvents: 'none' },
  };

  useOnClickOutside(menuRef, close);

  return (
    <div className='relative w-full' ref={menuRef}>
      <button
        onClick={toggle}
        className={classNames(
          'group relative flex h-12 w-full flex-col items-center justify-center outline-none hover:text-white focus:outline-none',
          isOpen
            ? 'bg-black bg-opacity-50 text-green'
            : 'text-gray-dark hover:bg-black hover:bg-opacity-20',
        )}
      >
        <GearIcon
          strokeWidth={5}
          className='stroke-current'
          width='16px'
          height='16px'
        />
        {isOpen ? (
          <div className='absolute top-0 bottom-0 left-0 right-0 border-r-5 border-r-green'></div>
        ) : null}
      </button>

      <Transition in={isOpen} timeout={500} nodeRef={transitionRef}>
        {(state) => (
          <div
            className='absolute left-16 bottom-1/4 z-50 ml-2 mb-2 h-auto w-42 overflow-hidden rounded-lg border border-gray-light bg-white shadow-md'
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
          >
            <SettingsMenu onClose={close} />
          </div>
        )}
      </Transition>
    </div>
  );
}

export default UserSettings;
